<router-outlet *ngIf="userContextIsInitialized"></router-outlet>
<div *ngIf="!userContextIsInitialized" class="widget-spinner">
  <div></div>
</div>
